import { Grid } from '@mui/material';
import FieldText from '../../../components/general/fields/fieldText';
import LoadingButtonGeneral from '../../../components/general/buttons/loadingButtonGeneral';
import { useUserFilters } from './hook';
import { UserFiltersProps } from './props';
import FieldSelect from '../../../components/general/fields/fieldSelect';

export const UserFilters = ({ onFilter, loading }: UserFiltersProps) => {
    const { formik, profiles } = useUserFilters(onFilter);

    return (
        <Grid container spacing={{ xs: 1.5, md: 1.5 }}>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Documento"
                    name="document"
                    size="small"
                    touched={formik.touched.document}
                    errors={formik.errors.document}
                    value={formik.values.document}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Nombre"
                    name="name"
                    size="small"
                    touched={formik.touched.name}
                    errors={formik.errors.name}
                    value={formik.values.name}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Apellido"
                    name="surname"
                    size="small"
                    touched={formik.touched.surname}
                    errors={formik.errors.surname}
                    value={formik.values.surname}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldSelect
                    data={profiles}
                    label="Perfil"
                    name="type"
                    size="small"
                    defineValue="value"
                    touched={formik.touched.type}
                    errors={formik.errors.type}
                    value={formik.values.type as string}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Correo"
                    name="username"
                    size="small"
                    touched={formik.touched.username}
                    errors={formik.errors.username}
                    value={formik.values.username}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12}>
                <LoadingButtonGeneral
                    disabled={loading}
                    title="Buscar"
                    sx={{ mr: 1 }}
                    onClick={formik.submitForm}
                />
                <LoadingButtonGeneral
                    disabled={loading}
                    title="Limpiar"
                    variant="outlined"
                    onClick={formik.resetForm}
                />
            </Grid>
        </Grid>
    );
};
